
export class KeyValuePair {
    key: string;
    value: string;
  }
  